import { render, staticRenderFns } from "./noCode.vue?vue&type=template&id=349cc45c&scoped=true&"
import script from "./noCode.vue?vue&type=script&lang=js&"
export * from "./noCode.vue?vue&type=script&lang=js&"
import style0 from "./noCode.vue?vue&type=style&index=0&id=349cc45c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349cc45c",
  null
  
)

export default component.exports